
<main-form-modal (toggleChange)="setVal($event)"> 
    <ng-template #customHtmlElements>
        <div [ngSwitch]="editMode">
           
            <honor-type-edit *ngSwitchCase="true"></honor-type-edit>
            <honor-type-details *ngSwitchCase="false"></honor-type-details>
        </div>
    </ng-template>  
</main-form-modal>